import Wrapper from "@/components/shared/Wrapper";
import HeaderPage from "@/components/layout/HeaderPage";
import * as Icons from "@/assets/features/requistion";
import { Check } from "lucide-react";
import ToggleRow from "@/components/shared/comman/requests/viewRequistiion/ToggleRow";
import SectionHeader from "@/components/shared/comman/requests/viewRequistiion/SectionHeader";
import JobDetailSection from "@/components/shared/comman/requests/viewRequistiion/JobDetailSection";
import TwoColumnRow from "@/components/shared/comman/requests/viewRequistiion/TwoColumnRow";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ConfirmationModal } from "@/components/shared/modals/ConfirmationModal";
import { VIEW_CANDIDATE_MODAL_KEYS } from "../constant/constant";
import { useState } from "react";
import ApproveModal from "../modals/ApproveModal";
import { useJobRequisitionStore } from "../store/useJobRequisitionStore";
import RejectionReasonModal from "../modals/RejectionReasonModal";

const basicInformationFields = [
  {
    field1: { label: "job title", value: "senior tester", required: true },
    field2: { label: "job category", value: "software", required: false },
    isAlternateBackground: true,
  },
  {
    field1: {
      label: "years of experience",
      value: "2-5 years",
      required: true,
    },
    field2: { label: "language required", value: "english", required: true },
  },
  {
    field1: { label: "education level", value: "bachelor", required: true },
    field2: { label: "career level", value: "senior tester", required: true },
    isAlternateBackground: true,
  },
  {
    field1: { label: "number of vacancies", value: "2", required: true },
    field2: {
      label: "work environment type",
      value: "senior tester",
      required: true,
    },
  },
  {
    field1: { label: "employment type", value: "tester", required: true },
    field2: { label: "travel", value: "senior tester", required: true },
    isAlternateBackground: true,
  },
  {
    field1: { label: "country", value: "2", required: true },
    field2: { label: "city", value: "cairo", required: true },
  },
  {
    field1: {
      label: "hiring priority",
      value: "software developers",
      required: false,
    },
    field2: {
      label: "requisitions reason",
      value: "senior tester",
      required: false,
    },
    isAlternateBackground: true,
  },
];

const dataCompensation = [
  {
    bg: "bg-sidebar",
    items: [
      { label: "currency", value: "EGP" },
      { label: "salary", value: "3000-5000" },
    ],
  },
  {
    bg: "",
    items: [
      {
        custom: (
          <div className="flex items-center gap-2 my-[1.5rem]">
            <div className="bg-primary pl-10 rounded-full pr-1 w-12 h-6 flex items-center justify-end">
              <div className="bg-white p-0.5 rounded-full h-5 w-5 flex items-center justify-center">
                <Check color="var(--color-primary)" height={15} />
              </div>
            </div>
            <p className="text-sm text-secondary font-medium">show salary</p>
          </div>
        ),
      },
      { label: "Additional salary", value: "3000-5000" },
    ],
  },
  {
    bg: "bg-sidebar",
    items: [
      {
        label: (
          <>
            end date <span className="text-destructive">*</span>
          </>
        ),
        value: "18/7/2025",
      },
      {},
    ],
  },
];

const jobDetailsSections = [
  {
    title: "Job Description",
    Icon: Icons.JobDescription,
    content: [
      {
        label: "Job Requirements",
        required: true,
        list: [
          "Created a modern, tabbed design with gradient backgrounds, enhanced metrics cards, and improved visual hierarchy.",
          "Created a modern, tabbed design with gradient backgrounds, enhanced metrics cards, and improved visual hierarchy.",
        ],
      },
      {
        label: "Roles & Responsibilities",
        required: true,
        list: [
          "Created a modern, tabbed design with gradient backgrounds, enhanced metrics cards, and improved visual hierarchy.",
          "Created a modern, tabbed design with gradient backgrounds, enhanced metrics cards, and improved visual hierarchy.",
        ],
      },
      {
        label: "Skills",
        tags: ["Compensation", "Collaboration"],
      },
      {
        label: "Job Keywords",
        tags: ["Testing", "Automation"],
      },
      {
        label: "Knowledge",
        tags: ["Manual Testing", "Agile Methodologies"],
      },
      {
        label: "Licenses",
        list: ["ISTQB Foundation Level"],
      },
      {
        label: "Certifications",
        list: ["ISTQB Foundation Level"],
      },
    ],
  },
];

// ==========================

const ViewRequisition = () => {
  const location = useLocation();
  const status = location?.pathname.split("/")[2];
  const {setActionModal} = useJobRequisitionStore();
  const navigate = useNavigate();


  return (
    <div>
      <HeaderPage pageTitle="requisition management" />
      <Wrapper className="py-[2rem] px-[2.813rem]">
        <h1 className="text-lg font-semibold">View Requisition</h1>

        {/* ==== Basic Information ==== */}
        <SectionHeader
          icon={<Icons.BasicInformation className="w-6 h-6" />}
          title="Basic Information"
        />
        <div className="text-secondary capitalize mt-[2rem] space-y-4">
          {basicInformationFields.map((data, index) => (
            <TwoColumnRow key={index} data={data} />
          ))}
        </div>

        {/* ==== Internal Hiring Toggle ==== */}
        <ToggleRow label="Internal Hiring Request enabled" />

        {/* ==== Compensation ==== */}
        <SectionHeader
          icon={<Icons.Compensation className="w-6 h-6" />}
          title="Compensation"
        />
        <div className="space-y-4">
          {dataCompensation.map((section, i) => (
            <div
              key={i}
              className={`text-secondary grid grid-cols-2 items-center p-[0.75rem] rounded-[1rem] ${section.bg}`}
            >
              {section.items.map((item, j) =>
                item.label || item.custom ? (
                  <div key={j}>
                    {item.custom ? (
                      item.custom
                    ) : (
                      <div className="space-y-1 capitalize">
                        <p className="text-sm">{item.label}</p>
                        <p className="text-sm font-semibold">{item.value}</p>
                      </div>
                    )}
                  </div>
                ) : (
                  <div key={j}></div>
                )
              )}
            </div>
          ))}
        </div>

        {/* ==== Job Details  ==== */}
        {jobDetailsSections.map((section, index) => (
          <JobDetailSection key={index} section={section} />
        ))}
      </Wrapper>
      {/* ===================== */}
      <Wrapper className="py-[2rem] px-[2.813rem] mt-5">
        <SectionHeader
          icon={<Icons.ApprovalWorkflow className="w-6 h-6" color="black" />}
          title="Approval Workflow"
        />

        <div className="grid grid-cols-2 items-center text-sm font-medium text-black mt-[2rem] ">
          <p>Approver Name</p>
          <p>Position</p>
        </div>
        <hr className="mt-[1.125rem]" />
        <div className="grid grid-cols-2 text-sm  items-center font-medium text-black mt-[1rem] ">
          <div className="flex items-center gap-5">
            <div>
              <p className="font-semibold text-md capitalize">Haidy magdy</p>
              <p className="text-sm text-secondary-foreground font-thin ">
                Haidy.magdy@company.com
              </p>
            </div>
          </div>{" "}
          <p>
            <div>
              <p className="font-semibold text-md capitalize">recruiter HR</p>
              <p className="text-sm text-secondary-foreground font-thin capitalize ">
                human resources
              </p>
            </div>
          </p>
        </div>
      </Wrapper>
      {/* ====================actions */}
      {status === "hiring" && (
        <Wrapper
          className={
            "flex flex-row items-center gap-2 justify-end  py-[2rem] px-[2.813rem] mt-5"
          }
        >
          <Button variant="destructive" className="bg-[#FF9500]  !py-[1.3rem]"
          onClick={() => navigate('modification/1')}
          >
            request modification
          </Button>
          <Button
            variant="destructive"
            className="bg-destructive-dark px-[5rem] !py-[1.3rem]"
            onClick={() => setActionModal(VIEW_CANDIDATE_MODAL_KEYS.REJECT)}
          >
            reject
          </Button>
          <Button
            variant="default"
            className=" px-[5rem] !py-[1.3rem]"
            onClick={() => setActionModal(VIEW_CANDIDATE_MODAL_KEYS.APPROVE)}
          >
            approve
          </Button>
        </Wrapper>
      )}
      {/* ==========Approve */}
     <ApproveModal/>
     {/* ========= reject */}
     <RejectionReasonModal/>
    </div>
  );
};

// ==========================

export default ViewRequisition;
